<template>
	<div class="artist-detail">
		<h3 class="artist-detail-title">About the artist</h3>

		<artwork-meta :metadata="artistDetails"></artwork-meta>

		<p v-if="artwork.art_gallery_rep" class="artist-detail-rep">
			<strong>{{ artwork.artist }}</strong>
			is represented by <em>{{ artwork.art_gallery_name }}</em>
		</p>

		<p class="artist-detail-statement" v-html="artwork.statement_full"></p>

	</div>
</template>

<script>
import ArtworkMeta from './ArtworkMeta.vue';

export default {
	components: {
		ArtworkMeta
	},

	props: {
		artwork: {
			type: Object,
			required: true
		},
		showSensitive: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		// Fix for artists who don't include HTTPS or HTTP in website URL.
		fixUrl(url) {
			if(url.includes("https://") || url.includes("http://")) {
				return url;
			}

			return "https://" + url;
		}
	},

	computed: {
		artistDetails() {
			var details = [
				{
					label: 'Name',
					value: this.artwork.artist_name,
					type: 'text'
				},
				{
					label: 'Category',
					value: this.categoryName,
					type: 'badge',
				},
			];

			// sensitive information (judges only)
			if (this.showSensitive) {
				details.push(
					{
						label: 'Curriculum Vitae',
						value: this.artwork.artist_cv,
						type: 'link',
						link_text: 'View CV'
					},
					{
						label: 'Social Media',
						value: this.artwork.artist_social_handles,
						type: 'text'
					},
					{
						label: 'Website',
						value: this.fixUrl(this.artwork.artist_website),
						type: 'link',
						link_text: 'Visit Website'
					}
				);

			}

			return details;
		},

		categoryName() {
			return this.artwork.category.name;
		}
	}
}
</script>